import i18n from "@/libs/i18n/i18n";

export const initialState = {
  searchDoctor: {},
  searchCashier: {},
  searchReturn: {},
  searchUnit: {countOfReferralsInClinic: 0},
  doctors: [],
  cashiers: [],
  insurances: [],
  searchedDrs: [],
  doctorReportRows: [],
  unitReportRows: [],
  cashierReportRows: [],
  cashierReportRowsPrint: [],
  returnReportRows: [],
  returnReportRowsPrint: [],
  returnTotal: 0,
  cashierTotal: 0,
  unitTotal: 0,
  countOfReferrals:[
    {value: 1, text: i18n.t("reports.unit.firstVisit")},
    {value: 0, text: i18n.t("reports.unit.allVisits")}],
  referralWays:[]
  }